export const breakpoints = {
  mobile: 768,
  desktop: 769,
  small: 480,
  extraSmall: 375,
  tablet: 1024
};

export const isMobileViewport = (width: number): boolean =>
  width <= breakpoints.mobile;
